module.exports = __webpack_public_path__ + "img/c25dc1246534958a4c7205e122c8234e.png";